var SERVER_URL = "https://transcriptcorrector.isl.iar.kit.edu/api";
const MOCK_BACKEND = false;

export { SERVER_URL, MOCK_BACKEND };
